import useSWR from "swr";
import { postFetcher } from "./fetcher";
import { useEffect } from "react";

function usePortfolioPrices(userPortfolio: any) {
    const { data: portfolioPrices, mutate: portMutate, isValidating } = useSWR(
        userPortfolio.length ? `/api/portfolio/allPortfolioPrice` : null,
        () =>
            postFetcher("/api/portfolio/allPortfolioPrice", {
                portfolios: userPortfolio,
            }),
        {
            revalidateOnMount: true,
            revalidateOnFocus: false,
            shouldRetryOnError: true,
        }
    );

    return [portfolioPrices, portMutate, isValidating];
}


export function usePortfolioPrice(userPortfolio: any, pf: string) {

    const currentPortfolioIdx = userPortfolio.findIndex(
        (portfolio: any) => portfolio.portName === pf
    );
    const currentPortfolio = userPortfolio[currentPortfolioIdx];

    const { data: portfolioPrice, mutate: portMutate, isValidating } = useSWR(
        userPortfolio.length && currentPortfolio ? `/api/portfolio/portfolioPrice?name=${currentPortfolio?.portName}` : null,
        () =>
            postFetcher("/api/portfolio/portfolioPrice", {
                portfolio: currentPortfolio,
            }),
        {
            revalidateOnMount: true,
            revalidateOnFocus: false,
            shouldRetryOnError: true,
        }
    );
    useEffect(() => {
        if (pf && portfolioPrice) {
            portMutate();
        }
    }, [pf]);

    return [portfolioPrice, portMutate, isValidating];
}
export default usePortfolioPrices;